/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Start_Chat_Project_Mode_ExistingInputs */



/**
* | output |
* | --- |
* | "Use Existing Project" |
*
* @param {Form_Start_Chat_Project_Mode_ExistingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_start_chat_project_mode_existing = /** @type {((inputs?: Form_Start_Chat_Project_Mode_ExistingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Start_Chat_Project_Mode_ExistingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestehendes Projekt verwenden")
	return /** @type {LocalizedString} */ ("Use Existing Project")
});